import { LegacyEquity, ScannerID, SynthOIEquity } from './equityhub';

export type AnyEquity = LegacyEquity | SynthOIEquity;
type EquityFilter = (equity: AnyEquity) => boolean;
type EquityComparator = (a: AnyEquity, b: AnyEquity) => number;

export interface StaticScanner {
  id: ScannerID;
  passes: EquityFilter;
  comparator?: EquityComparator;
  slice?: number;
}

export enum ScannerState {
  Selected,
  Active,
  Off,
}

export class Scanner {
  inner: StaticScanner;
  state: ScannerState;

  constructor(inner: StaticScanner, state: ScannerState | undefined) {
    this.inner = inner;
    this.state = state ?? ScannerState.Off;
  }

  isOn() {
    return (
      this.state === ScannerState.Selected || this.state === ScannerState.Active
    );
  }
}
